import { makeStyles } from "@mui/styles";
import { useMemo, useState } from "react";
import { RTFO } from "../components/rtfo/RTFO";
import { useDispatch, useSelector } from "react-redux";
import { selectRTFO, setCurrentStageName } from "../reducers/rtfoSlice";
import RTFOMapPadActivity from "../components/rtfo/RTFOMapPadActivity";

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    backgroundColor: theme.palette.grey[100],
    border: 0,
    color: 'text.primary',
    height: '100vh',
    width: 'calc(100% - 60px)',
    paddingTop: 30,
    marginLeft: 60,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
}));

const KEY_DOWN = 40;
const KEY_UP = 38;

export const RTFOContainer = () => {
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const rtfo = useSelector(selectRTFO);
  const currentRTFO = rtfo?.value;

  const [currentWellName, setCurrentWellName] = useState('All');

  const rtfoMemo = useMemo(() => {
    return (
      <RTFO currentWellName={currentWellName} setCurrentWellName={setCurrentWellName} />
    );
  }, [currentWellName]);


  if (document.title !== ('RTFO | SSD')) document.title = ('RTFO | SSD');

  return (
    <div 
      className={classes.root}
      onKeyDown={handleKeyDown}
      tabIndex="0"
    > 
      {currentRTFO ? rtfoMemo : <RTFOMapPadActivity />}
    </div>
  );

  function handleKeyDown(event) {
    try {

      if (currentRTFO?.isLoadingData) return; // prevent stage switching while data is loading

      let stageNames = currentRTFO?.stageData ? Object.keys(currentRTFO?.stageData) : [];
      if (currentWellName !== 'All') {
        stageNames = stageNames.filter(name => name.includes(currentWellName));
      };
      stageNames?.sort((a, b) => currentRTFO?.stageData?.[b]?.stageStartTimestamp - currentRTFO?.stageData?.[a]?.stageStartTimestamp);

      if (stageNames.length === 0) return;

      const currentStageIndex = stageNames.indexOf(currentRTFO?.currentStageName);

      let newStageName = null;

      if (event.keyCode === KEY_DOWN) {
        newStageName = stageNames[currentStageIndex + 1] || null;
      } else if (event.keyCode === KEY_UP) {
        newStageName = stageNames[currentStageIndex - 1] || null;
      };


      if (newStageName) {
        dispatch(setCurrentStageName(newStageName));
      };
      
    } catch (error) {
      console.log(error);
    };
    
  };
};
